import { render, staticRenderFns } from "./GPT.vue?vue&type=template&id=97db6bc6&scoped=true"
import script from "./GPT.vue?vue&type=script&lang=js"
export * from "./GPT.vue?vue&type=script&lang=js"
import style0 from "./GPT.vue?vue&type=style&index=0&id=97db6bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97db6bc6",
  null
  
)

export default component.exports